import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  GetPreProposal,
  UpdatePreProposal,
  PendingPreProposal,
  ApprovePreProposal,
  GetPreProposalByHash,
} from '../../../store/actions';

/**
 * ValidationOfProposalsInjetion is responsible for injecting the methods about store.
 *
 * @return
 *  get: () => Void
 *
 */
export const ValidationOfProposalsInjetion = () => {
  /* constants */
  const dispatch = useDispatch();

  /**
   * @connectors
   *
   * these methods are responsible for accessing the store and dispatch the actions.
   * these guarantee that the module will be connected independent of methods used.
   * but you should always follow the rules of the methods.
   */

  /**
   * @return Void
   *
   */

  const getPreProposals = () => {
    dispatch(GetPreProposal());
  };

  const getPreProposalByHash = useCallback(
    (hash) => {
      dispatch(GetPreProposalByHash(hash));
    },
    [dispatch]
  );

  const updatePreProposal = (hash, data) => {
    dispatch(UpdatePreProposal(hash, data));
  };

  const pendingPreProposal = (hash, data) => {
    dispatch(PendingPreProposal(hash, data));
  };

  const approvePreProposal = (hash, history) => {
    dispatch(ApprovePreProposal(hash, history));
  };

  const { success, loading, preProposals, preProposalByHash } = useSelector(
    (state) => ({
      preProposals: state.ValidationOfProposals.preProposals,
      loading: state.ValidationOfProposals.loading,
      success: state.ValidationOfProposals.success,
      preProposalByHash: state.ValidationOfProposals.preProposalByHash,
    })
  );

  return {
    loading,
    success,
    preProposals,
    getPreProposals,
    updatePreProposal,
    preProposalByHash,
    approvePreProposal,
    pendingPreProposal,
    getPreProposalByHash,
  };
};
